/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Birthday_Event_Paywall_TitleInputs */

const en_birthday_event_paywall_title = /** @type {(inputs: Birthday_Event_Paywall_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring Back the Trees You Missed`)
};

const ar_birthday_event_paywall_title = /** @type {(inputs: Birthday_Event_Paywall_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استعد الأشجار التي فاتتك`)
};

const de_birthday_event_paywall_title = /** @type {(inputs: Birthday_Event_Paywall_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring die Bäume zurück, die du verpasst hast`)
};

const es_birthday_event_paywall_title = /** @type {(inputs: Birthday_Event_Paywall_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trae de vuelta los árboles que te perdiste`)
};

const fr_birthday_event_paywall_title = /** @type {(inputs: Birthday_Event_Paywall_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ramenez les arbres que vous avez manqués`)
};

const it_birthday_event_paywall_title = /** @type {(inputs: Birthday_Event_Paywall_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riporta gli alberi che hai perso`)
};

const ja_birthday_event_paywall_title = /** @type {(inputs: Birthday_Event_Paywall_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逃した樹木を取り戻そう`)
};

const ko_birthday_event_paywall_title = /** @type {(inputs: Birthday_Event_Paywall_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`놓친 나무들을 다시 데려오세요`)
};

const pt_br_birthday_event_paywall_title = /** @type {(inputs: Birthday_Event_Paywall_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traga de volta as árvores que você perdeu`)
};

const ru_birthday_event_paywall_title = /** @type {(inputs: Birthday_Event_Paywall_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Верните деревья, которые вы упустили`)
};

const th_birthday_event_paywall_title = /** @type {(inputs: Birthday_Event_Paywall_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นำต้นไม้ที่คุณพลาดไปกลับมา`)
};

const tr_birthday_event_paywall_title = /** @type {(inputs: Birthday_Event_Paywall_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaçırdığınız ağaçları geri getirin`)
};

const zh_cn_birthday_event_paywall_title = /** @type {(inputs: Birthday_Event_Paywall_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把你错过的树带回森林`)
};

const zh_tw_birthday_event_paywall_title = /** @type {(inputs: Birthday_Event_Paywall_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把你錯過的樹帶回森林`)
};

/**
* | output |
* | --- |
* | "Bring Back the Trees You Missed" |
*
* @param {Birthday_Event_Paywall_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const birthday_event_paywall_title = /** @type {((inputs?: Birthday_Event_Paywall_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Birthday_Event_Paywall_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_birthday_event_paywall_title(inputs)
	if (locale === "ar") return ar_birthday_event_paywall_title(inputs)
	if (locale === "de") return de_birthday_event_paywall_title(inputs)
	if (locale === "es") return es_birthday_event_paywall_title(inputs)
	if (locale === "fr") return fr_birthday_event_paywall_title(inputs)
	if (locale === "it") return it_birthday_event_paywall_title(inputs)
	if (locale === "ja") return ja_birthday_event_paywall_title(inputs)
	if (locale === "ko") return ko_birthday_event_paywall_title(inputs)
	if (locale === "pt_br") return pt_br_birthday_event_paywall_title(inputs)
	if (locale === "ru") return ru_birthday_event_paywall_title(inputs)
	if (locale === "th") return th_birthday_event_paywall_title(inputs)
	if (locale === "tr") return tr_birthday_event_paywall_title(inputs)
	if (locale === "zh_cn") return zh_cn_birthday_event_paywall_title(inputs)
	return zh_tw_birthday_event_paywall_title(inputs)
});